import { NewsletterStorage } from "@Engage.Data/services/storage/NewsletterStorage";
/**
 * NewsletterReaderQualifier
 * Checks whether the user arrived via a newsletter link (nxt_nl_reader cookie).
 * Returns "true" if the cookie exists, "false" otherwise.
 * Server compares this against qualifier.Value ("true"/"false").
 */
export class NewsletterReaderQualifier {
    constructor() {
        this.key = "NewsletterReader";
    }
    process() {
        try {
            const newsletterReader = NewsletterStorage.getNewsletterReader();
            return newsletterReader != null ? "true" : "false";
        }
        catch (_a) {
            return "false";
        }
    }
}
